<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/basic/defectCode/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('quexianleixingmingcheng')">
						<yi_data_select :type="'defect_search'" :ids.sync="yt.conditions.levelTwoDefectTypeIds">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('quexiandaima')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('quexianmiaoshu')">
						<el-input v-model="yt.conditions.desc"></el-input>
					</el-form-item>
          <!--工序编码-->
          <el-form-item  :label="$t('gongxubianma/miaoshu')">
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.conditions.workProcedureIds" multiple>
              <el-option v-for="(item, index) in codeAndDesc" :key="index" :label="item.codeAndDesc"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'code asc'})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_base_defect_code_create')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue();getProcedureCode()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button v-if="utils.checkPower('web_base_defect_code_batchImport')" size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
      <template #gongxubianmamiaoshu="scope">
        <span v-if="scope.row.workProcedure">{{scope.row.workProcedure.code}}/{{scope.row.workProcedure.desc}}</span>
<!--        ?({{scope.row.code}}/{{scope.row.desc}}):''-->
      </template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_defect_code_update')" type="text" @click="yt.showEditDialog('bianji', scope.row);getProcedureCode()">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_defect_code_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/defectCode/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('quexianleixingmingcheng')" required>
						<yi_data_select :showAllLevels="true" :type="'defect_add'" :ids.sync="yt.editObj.levelTwoDefectTypeId">
						</yi_data_select>
					</el-form-item>
					<el-form-item :label="$t('quexiandaima')" required>
						<el-input v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('quexianmiaoshu')" required>
						<el-input  v-model="yt.editObj.desc"></el-input>
					</el-form-item>
          <el-form-item :label="$t('quexiandengji')" required>
            <yi_dictionary_select :type="'DEFECT_LEVEL'" :ids.sync="yt.editObj.level" @change="$forceUpdate()">
            </yi_dictionary_select>
          </el-form-item>
          <!--工序编码-->
          <el-form-item  :label="$t('gongxubianma/miaoshu')" required>
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.editObj.workProcedureId">
              <el-option v-for="(item, index) in codeAndDesc" :key="index" :label="item.codeAndDesc"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectCode/create')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('yijiquexianleixingmingcheng')" required>
            <el-input disabled v-model="yt.editObj.levelOneDefectType.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('erjiquexianleixingmingcheng')" required>
            <el-input disabled v-model="yt.editObj.levelTwoDefectType.name"></el-input>
          </el-form-item>
					<el-form-item class="noborder" :label="$t('quexiandaima')" required>
						<el-input disabled v-model="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('quexianmiaoshu')" required>
						<el-input v-model="yt.editObj.desc"></el-input>
					</el-form-item>
          <el-form-item :label="$t('quexiandengji')" required>
            <yi_dictionary_select :type="'DEFECT_LEVEL'" :ids.sync="yt.editObj.level">
            </yi_dictionary_select>
          </el-form-item>
          <!--工序编码-->
          <el-form-item  :label="$t('gongxubianma/miaoshu')" required>
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.editObj.workProcedureId">
              <el-option v-for="(item, index) in codeAndDesc" :key="index" :label="item.codeAndDesc"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectCode/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 导入excel -->
		<importExcel :show.sync="show" />
	</div>
</template>
<script type="text/javascript">
	import importExcel from '@@/pages/web/base/defect/defect_code/import_excel'
	export default {
		name: 'web_base_defect_defect_code_list',
		components: {
			importExcel
		},
		data() {
			return {
				show: false,
        codeAndDesc:'',
				columns: [ {
					label: 'yijiquexianleixingmingcheng',
					prop: 'levelOneDefectType.name',
					width: 150
				}, {
					label: 'erjiquexianleixingmingcheng',
					prop: 'levelTwoDefectType.name',
					width: 150
				}, 
				{
					label: 'quexiandaima',
					prop: 'code'
				},
				{
					label: 'quexianmiaoshu',
					prop: 'desc'
				},
				{
					label: 'quexiandengji',
					prop: 'level',
          width: 150,
					type: 'tag',
					tags: {
						1: {
							color: '#909399',
							text: this.$t('qingweiquexian')
						},
						2: {
							color: '#419FFF',
							text: this.$t('yibanquexian')
						},
						3: {
							color: '#E6A23C',
							text: this.$t('yanzhongquexian')
						},
						4: {
							color: '#F56C6C',
							text: this.$t('zhimingquexian')
						}
					},
				},
          {
            label: 'gongxubianmamiaoshu',
            type: 'slot',
            width: 150
          },
				{
					label: 'chuangjianren',
					prop: 'createByObject.nickname'
				},
				{
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					// format: 'YYYY-MM-DD HH:mm'
				}, 
				{
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
        this.getProcedureCode()
				//表格默认按照异常类型编码升序排序。
				this.yt.conditions = {
					orderBy:'code asc',

				}
				this.yt.get(1);
				this.utils.event_hub.$on('WEB_DEFECT_CODE_REFRESH', () => {
					this.yt.get(1);
				})
			}, 300)
		},
		methods: {
      getProcedureCode() {
        this.http.get('/web/craft/basic/work/procedure/list').then(res=>{
          this.codeAndDesc = res.data
          if(this.yt.editObj.action == 'xinzeng'){
            this.yt.editObj.workProcedureId = this.codeAndDesc[0].id
          }
        })
      },
		setDefaultValue(){
			// this.yt.editObj.status = 1;
		},
		}
	};
</script>
